import Request from "../../../lib/request";
import { PROJECT_USER_ID } from "../../../constants/storageKeys";
import { FILE_TYPE } from "../../../constants/filters";
import { FILE_TYPES } from "../../../constants/file";
import {
  MONTHLY_BUDGET_LIST_API,
  PROJECT_USERS_API,
  REPORTS_API
} from "../../../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const get = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${REPORTS_API}/${MONTHLY_BUDGET_LIST_API}`,
    needToken: true,
    data: { [FILE_TYPE]: FILE_TYPES.WEB }
  });
};
